export const basicStatuses = [
  {
    label: "Warning (Conversion Error)",
    name: "Warning (Conversion Error)"
  },
  {
    label: "Warning (Missing Fields)",
    name: "Warning (Missing Fields)"
  },
  {
    label: "Warning (Potential Error Identified)",
    name: "Warning (Potential Error Identified)"
  },
  {
    label: "Emissions Included (User Confirmed)",
    name: "Emissions Included (User Confirmed)"
  },
]

export const approvalFlowStatuses = [
  {
    label: "Reviewed",
    name: "Reviewed"
  },
]

export const notApplicableStatuses = [
  {
    label: "Not Applicable (Invalid Data)",
    name: "Not Applicable (Invalid Data)"
  },
  {
    label: "Not Applicable (Cost Only)",
    name: "Not Applicable (Cost Only)"
  },
];
